let scrollY = 0;
const frozenKeys = /* @__PURE__ */ new Set();
function freeze(key) {
  if (!window || !(document == null ? void 0 : document.body)) {
    return;
  }
  if (frozenKeys.size === 0) {
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    scrollY = window.pageYOffset;
    document.body.style.overflow = "hidden";
    document.body.style.marginRight = `${scrollbarWidth.toString()}px`;
  }
  frozenKeys.add(key);
}
function unfreeze(key) {
  frozenKeys.delete(key);
  if (!window || !(document == null ? void 0 : document.body) || frozenKeys.size > 0) {
    return;
  }
  document.body.style.overflow = "";
  document.body.style.marginRight = "";
  window.scrollTo(0, scrollY || 0);
}
export { freeze, unfreeze };
